




























































import {
  ref,
  computed,
  defineComponent,
  PropType
} from '@nuxtjs/composition-api';

import {
  getSwatchData as getProductSwatchData,
  getName as getProductName
} from '@wemade-vsf/catalog/lib/runtime/product/getters/productGetters';
import { useCustomerPricing } from '@wemade-vsf/catalog/lib/runtime/product/composables/useCustomerPricing';
import ProductPrice from 'components/catalog/Product/ProductPrice.vue';
import type { BundleOptionInput } from '@wemade-vsf/magento-api';
import BundleProductSelector from 'components/catalog/Product/ProductTypes/bundle/BundleProductSelector.vue';
import { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';
import BundleProductOptionSkeleton
  from 'components/catalog/Product/ProductTypes/bundle/BundleProductOptionSkeleton.vue';
import ProductDetails from 'components/catalog/Product/Details/ProductDetails.vue';
import ProductActions from 'components/catalog/Product/Details/ProductActions.vue';

export default defineComponent({
  name: 'BundleProduct',
  components: {
    BundleProductOptionSkeleton,
    BundleProductSelector,
    ProductPrice,
    ProductDetails,
    ProductActions
  },
  transition: 'fade',
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    isFetching: {
      type: Boolean,
      default: true,
    }
  },
  setup(props) {
    const { getPriceForProduct } = useCustomerPricing();
    const productPrices = computed(() => getPriceForProduct(props.product));
    const customizationPrice = ref(productPrices.value.special ?? productPrices.value.regular);
    const bundleOptions = ref<BundleOptionInput[]>([]);
    const qty = ref(1)

    function updateBundleOptions(options: BundleOptionInput[]) {
      bundleOptions.value = options;
    }

    return {
      getProductName,
      getProductSwatchData,
      updateBundleOptions,
      bundleOptions,
      qty,
      productPrices,
      customizationPrice
    };
  },
});
